import { useMemo } from "react";

export default function TrophyIcon({ position }) {
  const trophyColor = useMemo(() => {
    switch (position) {
      case 1:
        return "#FFDC23";
      case 2:
        return "#9E9E9E";
      case 3:
        return "#D09337";
      default:
        return "#000000";
    }
  }, [position]);

  return (
    <div className="TrophyIcon">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_13_1769)">
          <path
            d="M5.12548 20.5745L2.09912 26.6262C1.95361 26.917 1.96923 27.2625 2.13989 27.5388C2.31103 27.8149 2.6123 27.9832 2.93725 27.9832H7.48974L10.2212 31.625C10.3987 31.8625 10.6772 32 10.9705 32C11.3599 32 11.6667 31.7676 11.8093 31.4819L14.6611 25.7781C10.8054 25.4094 7.406 23.4543 5.12548 20.5745Z"
            fill="#FF4058"
          />
          <path
            d="M29.8843 26.6262L26.8579 20.5745C24.5774 23.4543 21.178 25.4094 17.3223 25.7781L20.1743 31.4819C20.3166 31.7676 20.6235 32 21.0129 32C21.3062 32 21.585 31.8625 21.7625 31.625L24.4937 27.9832H29.0461C29.3711 27.9832 29.6724 27.8149 29.8435 27.5388C30.0142 27.2625 30.0298 26.917 29.8843 26.6262Z"
            fill="#FF4058"
          />
          <path
            d="M27.9668 11.9834C27.9668 5.37573 22.5911 0 15.9834 0C9.37573 0 4 5.37573 4 11.9834C4 18.5908 9.37573 23.9668 15.9834 23.9668C22.5911 23.9668 27.9668 18.5911 27.9668 11.9834Z"
            fill={trophyColor}
          />
        </g>
        <defs>
          <clipPath id="clip0_13_1769">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <span>{position}</span>
    </div>
  );
}
